import { useEffect, useState } from 'react';
import type { Locale } from 'date-fns';
import { getDayPickerLocale, getDefaultLocale } from './day-picker-locale';

/**
 * Load the date-fns locale matching the current WordPress locale.
 */
export function useDayPickerLocale(): {
	locale: Locale;
	localeLoading: boolean;
} {
	const [locale, setLocale] = useState(getDefaultLocale);
	const [localeLoading, setLocaleLoading] = useState(true);

	useEffect(() => {
		let mounted = true;

		getDayPickerLocale()
			.then((loadedLocale) => {
				if (mounted) {
					setLocale(loadedLocale);
					setLocaleLoading(false);
				}
			})
			.catch((error) => {
				// eslint-disable-next-line no-console
				console.error('Failed to load locale:', error);

				if (mounted) {
					setLocale(getDefaultLocale());
					setLocaleLoading(false);
				}
			});

		return () => {
			mounted = false;
		};
	}, []);

	return { locale, localeLoading };
}
